!(function () {
  'use strict';
  customElements.get('parallax-hero') ||
    customElements.define(
      'parallax-hero',
      class extends HTMLElement {
        defaultOptions = {center: true, round: true, frame: this};

        constructor() {
          super();
          this.rellax = null;
          this.refreshEvent = window.theme.debounce(() => {
            this.refresh();
          }, 500);
        }

        connectedCallback() {
          const img = this.querySelector('[data-parallax-img]');
          if (!img) return;

          const speed = this.getAttribute('data-parallax-speed') || -2;
          const options = {...this.defaultOptions, speed: parseFloat(speed)};
          const Rellax = window.themeRellax?.Rellax || window.Rellax;
          this.rellax = new Rellax(img, options);

          document.addEventListener('theme:resize', this.refreshEvent);

          const refreshOnFrame = () => requestAnimationFrame(() => this.refresh());
          if (document.readyState === 'complete') {
            refreshOnFrame();
          } else {
            window.addEventListener('load', refreshOnFrame, {once: true});
          }

          // Lazy images and slider init can shift layout after the initial
          // measurement, leaving the image mis-translated (cropped top / gap
          // at bottom). Re-measure when the actual <img> finishes loading,
          // on first approach into the viewport, and on staggered timers.
          const innerImg = img.querySelector('img');
          if (innerImg && !innerImg.complete) {
            innerImg.addEventListener('load', refreshOnFrame, {once: true});
          }

          if ('IntersectionObserver' in window) {
            this.io = new IntersectionObserver(
              (entries) => {
                if (entries.some((entry) => entry.isIntersecting)) {
                  refreshOnFrame();
                  this.io.disconnect();
                  this.io = null;
                }
              },
              {rootMargin: '300px'}
            );
            this.io.observe(this);
          }

          this.refreshTimers = [500, 1500, 3500].map((ms) => setTimeout(refreshOnFrame, ms));
        }

        refresh() {
          this.rellax?.refresh();
        }

        disconnectedCallback() {
          this.rellax?.destroy();
          document.removeEventListener('theme:resize', this.refreshEvent);
          this.io?.disconnect();
          this.refreshTimers?.forEach((t) => clearTimeout(t));
        }
      }
    );
})();
